<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <div v-show="!!multiple || !photos.length">
                    <div class="d-flex justify-content-center">
                    <div class="d-flex justify-content-center" id="canvas-container" :style="`width: ${width}px; height: ${height}px; max-width: 100%`">
                        <video
                            v-show="cameraOn"
                            class="camera-frame"
                            ref="video"
                            :width="width"
                            :height="height"
                            style="max-width: 100%;"
                            
                        ></video>
                        
                        <div
                            v-if="!cameraOn"
                            :style="`width: ${width}px; height: ${height}px;`"
                            class="camera-dummy d-flex justify-content-center align-items-center"
                        ><i class="fa fa-camera fa-5x"></i></div>
                        
                        <canvas
                            ref="canvas"
                            style="display: none; max-width: 100%;"
                            :width="width"
                            :height="height"
                        ></canvas>
                    </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center" v-if="!multiple && this.photos.length === 1">
                    <!-- <div v-if="!multiple && photos.length === 1" class="my-2 camera-frame" :style="`width: ${width}px; height: ${height}px`"> -->
                    <!-- <div v-if="!multiple && photos.length === 1" class="my-2 camera-frame"> -->
                        <!-- <img :src="photos[0]" alt="" class="camera-frame" style="width: 100%; height: 100%;"> -->
                        <b-img
                            :src="photos[0]"
                            fluid
                            thumbnail
                            :width="realWidth"
                            :height="realHeight"
                        ></b-img>
                    <!-- </div> -->
                </div>
            </b-col>

            <b-col cols="12" v-if="upload" class="my-2">
                <label for="visitor-photo"><strong>Subir Foto</strong></label>
                <b-form-file
                    accept="image/*"
                    name="visitor-photo"
                    @change="onChangeFile"
                    placeholder="Seleccione la foto"
                ></b-form-file>
            </b-col>

            <b-col cols="12" class="mt-2">
                <b-select text-field="label" value-field="deviceId" :options="devices" :value="selectedDevice" @change="changeDevice"></b-select>
            </b-col>
            <b-col cols="12" class="my-2">
                <b-row>
                    <b-col cols="12">
                        <b-row align-h="center">
                            <b-col v-if="!cameraOn && !(!multiple && photos.length === 1)">
                                <b-button block variant="success" @click="turnOn" title="Prender Cámara"><i class="fa fa-power-off"></i></b-button>
                            </b-col>
                            <b-col v-if="cameraOn">
                                <b-button block variant="danger" @click="turnOff" title="Apagar Cámara"><i class="fa fa-power-off"></i></b-button>
                            </b-col>
                            <b-col v-if="cameraOn && (multiple || (!multiple && photos.length === 0))">
                                <b-button block  variant="primary" @click="takePhoto" title="Tomar Foto"><i class="fa fa-camera"></i></b-button>
                            </b-col>
                            <b-col v-if="!multiple && photos.length === 1">
                                <b-button block variant="danger" @click="restartPhoto"><i class="fa fa-trash" title="Eliminar Foto"></i></b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="!!multiple">
            <b-col cols="12">
                <small v-if="!!photos.length" class="mx-2">Click sobre la foto para eliminarla</small>
                <b-row>
                    <b-col cols="6" md="4" v-for="(photo, index) in photos" :key="index" class="mb-2">
                        <!-- <img :src="photo" alt="" class="thumbnail" width="99%" @click="deletePhoto(index)"> -->
                        <b-img :src="photo" alt="" thumbnail fluid @click="deletePhoto(index)" />
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { cookies } from '../../../../mixin';
export default {
    name: 'WebCam',
    mixins: [cookies],
    props: {
        size: {
            type: String,
            validator: (val) => ['small', 'medium', 'large'].includes(val),
            default: 'small'
        },
        multiple: {
            type: Boolean,
            default: () => true
        },
        id: {
            type: String,
            default: 'webcam'
        },
        facingMode: {
            type: String,
            validator: val => ['user', 'environment', 'default'].includes(val),
            default: 'default' 
        },
        ratio: {
            type: String,
            validator: value => {
                return /^\d+:\d+$/.test(value);
            },
            default: '4:3'
        },
        upload: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            video: null,
            canvas: null,
            stream: null,
            devices: [],
            cameraOn: false,
            selectedDevice: '',
            photos: [],
            realWidth: '',
            realHeight: ''
        }
    },
    computed: {
        width() {
            const widths = { small: 320, medium: 640, large: 1024 };
            return widths[this.size];
        },
        height() {
            // const heights = { small: 240, medium: 480, large: 768 };
            const ratioParts = this.ratio.split(':');
            const ratio = ratioParts[0] / ratioParts[1];
            // return heights[this.size];
            return this.width / ratio;
        },
        cameraSizeClass() {
            return `camera-${this.size}`;
        }
    },
    methods: {
        onChangeFile(event) {
            const file = !!event.target.files?event.target.files[0]: null;
            if(!file) return;

            const fr = new FileReader();
            fr.addEventListener('load', (e) => {
                this.$emit('input', e.target.result);
            });
            fr.readAsDataURL(file);
        },
        autoSelectDevice() {
            if(!this.devices.length || this.facingMode !== 'default') return false;

            // Validar si existe cookie con camara por defecto
            const defaultCam = this.getCookie('_bitacorapp_default_cam_');
            
            if(!!defaultCam){
                this.selectedDevice = defaultCam;
                return;
            }

            this.selectedDevice = this.devices[this.devices.length - 1].deviceId;
        },
        changeDevice(deviceId) {
            this.selectedDevice = deviceId;
            this.setDefaultCam(deviceId);
            this.turnOff();
            this.turnOn();
        },
        setDefaultCam(deviceId){
            this.setCookie('_bitacorapp_default_cam_', deviceId);
        },
        turnOn() {


            const constraints = {
                video: {
                    deviceId: this.selectedDevice,
                    width: { exact: this.width }, 
                    height: { exact: this.height }
                    
                }
            }

            if(this.facingMode !== 'default'){
                constraints.video = { ...constraints.video, facingMode: this.facingMode };
            }

            this.cameraOn = true;
            // navigator.mediaDevices.getUserMedia(constraints)

            navigator.getUserMedia = navigator.getUserMedia ||
                        navigator.webkitGetUserMedia ||
                        navigator.mozGetUserMedia ||
                        navigator.mediaDevices.getUserMedia;

            if(!navigator.getUserMedia) {
                toastr.error('Navegador incompatible con Bitacorapp');
                return false;
            }

            navigator.getUserMedia(constraints, stream => {
                this.stream = stream;
                this.video.srcObject = stream;
                this.video.onloadedmetadata = e => {
                    this.video.play();
                }
            }, error => {
                toastr.error('Ocurrió un error encendiendo la cámara');
            });

        },
        turnOff() {
            if(!this.stream) return false;

            this.stream.getVideoTracks().forEach(track => track.stop());
            this.cameraOn = false;
        },
        takePhoto() {
            const width = $('#canvas-container').width();
            const height = $('#canvas-container').height();

            const ratio = this.width / this.height;
            const minWidth = Math.min(width, this.width);
            const minHeight = minWidth / ratio;

            this.canvas.width = minWidth;
            this.canvas.height = minHeight;
            const context = this.canvas.getContext('2d');

            // context.drawImage(this.video, 0, 0, this.width, this.height);
            context.drawImage(this.video, 0, 0, minWidth, minHeight);

            const photo = this.canvas.toDataURL('image/png', 0.8);
            this.photos.push(photo);

            if(!this.multiple) this.turnOff();

            this.$emit('input', this.multiple? this.photos: photo);
        },
        deletePhoto(index) {
            this.photos.splice(index, 1);
            this.$emit('input', this.multiple? this.photos: null);
        },
        restartPhoto() {
            this.deletePhoto(0);
            this.turnOn();
        },
        resetPhotos(){
            this.photos = [];
        }
    },
    mounted() {
        this.video = this.$refs.video;
        this.canvas = this.$refs.canvas;
        // this.canvas.width = this.width;
        // this.canvas.height = this.height;

        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
            navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                this.devices = devices.filter(item => item.kind === 'videoinput').map((item, index) => ({ deviceId: item.deviceId, label: item.label || `Camara ${index + 1}` }));
                this.autoSelectDevice();
            })
            .catch(error => {
                toastr.error('Ocurrió un error inicializando los dispositivos multimedia');
            });
        }
    },
    created() {
        this.$bus.$on(`${this.id}.off`, this.turnOff);
        this.$bus.$on(`${this.id}.on`, this.turnOn);
        this.$bus.$on('reset-photos', this.resetPhotos);
    },
    beforeDestroy() {
        this.turnOff();
        this.$bus.$off(`${this.id}.off`);
        this.$bus.$off(`${this.id}.on`);
        this.$bus.$on('reset-photos', this.resetPhotos);
    }
}
</script>
<style scoped>
.camera-frame {
    display: inherit;
    border-radius: 10px;
}

.camera-small {
    width: 320px;
    max-width: 100%!important;
    height: 240px;
}

.camera-medium {
    width: 640px;
    max-width: 100%;
    height: 480px;
}

.camera-large {
    width: 1024px;
    max-width: 100%;
    height: 768px;
}

.thumbnail {
    border-radius: 3px;
}

.camera-dummy {
    border-radius: 6px;
    border: 2px dashed lightgrey;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Buscar';
}
</style>